import React, { useEffect, useState } from "react";
import style from "./TounchSkuTable.module.css";

const   TounchSkuTable = ({ columns,resetTable, data,setAllSelectedSkus,isReset }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  // Handle individual row selection
  const handleRowSelection = (product) => {
    const isSelected = selectedItems.some((item) => item.Id === product.Id);
    if (isSelected) {
      setSelectedItems(selectedItems.filter((item) => item.Id !== product.Id));
    } else {
      setSelectedItems([...selectedItems, product]);
    }
  };

  useEffect(()=>{
    setIsAllSelected(false)
    setSelectedItems([])
  },[data,isReset,resetTable])
  // Handle "Select All" functionality
  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedItems([]);
    } else {
      setSelectedItems(data);
    }
    setIsAllSelected(!isAllSelected);
  };

  useEffect(()=>{
     if(selectedItems?.length){
        setAllSelectedSkus(selectedItems)
     }
  },[selectedItems])

  console.log("Selected Items:", selectedItems);

  return (
    <div className={style["table-container"]} style={{ marginBottom: "20px" }}>
      <table className={style["custom-table"]}>
        <thead style={{ backgroundColor: "#627383", color: "#FFFFFF" }}>
          <tr>
            {/* Checkbox column in header */}
            <th
              style={{
                padding: "8px",
                border: "1px solid #ccc",
                textAlign: "center",
                backgroundColor: "#627383",
                color: "#fff",
                fontSize: "12px",
                fontWeight: "600",
                minWidth: "fit-content",
              }}
            >
              <input
                style={{boxShadow:"none"}}
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
            </th>
            {columns?.map((column) => (
              <th
                key={column.key}
                style={{
                  padding: "8px",
                  border: "1px solid #ccc",
                  textAlign: "center",
                  backgroundColor: "#627383",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "600",
                  minWidth: "fit-content",
                }}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((product, idx) => (
            <tr
              key={product.Id}
              className={`${style.tableRow} ${
                idx % 2 === 0 ? style.evenRow : style.oddRow
              }`}
            >
              {/* Checkbox column in body */}
              <td style={{ textAlign: "center" }}>
                <input
                style={{boxShadow:"none"}}
                  type="checkbox"
                  checked={selectedItems.some((item) => item.Id === product.Id)}
                  onChange={() => handleRowSelection(product)}
                />
              </td>
              {columns.map((column) => (
                <>
                  {column?.key === "serialNumber" ? (
                    <td
                      style={{ fontSize: "12px" }}
                      key={column.key}
                      className={style.tableCell}
                    >
                      {idx + 1}
                    </td>
                  ) : (
                    <td
                      style={{ fontSize: "12px" }}
                      key={column.key}
                      className={style.tableCell}
                    >
                      {column.type === "read" &&
                        (column.calculate
                          ? column.calculate(product)
                          : product[column.key])}
                    </td>
                  )}
                </>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TounchSkuTable;
